import React from 'react';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import InsuranceModuleView from 'partial/OfferManager/modules/InsuranceModuleRedesign/InsuranceModuleView';
import { useLinkHandler } from 'hook/event.hook';
import 'partial/OfferManager/modules/InsuranceModuleRedesign/insuranceCarousel.scss';

export const InsuranceModuleController = props => {
  const { tiles, eventHandler, modulePosition } = props;
  const loading = props.globalLoadingFlag;
  const onLinkClickCallback = useLinkHandler(props.eventHandler);
  if (loading) {
    return <LoadingMask />;
  } else
    return (
      <InsuranceModuleView
        eventHandler={eventHandler}
        offerTiles={tiles}
        onLinkClickCallback={onLinkClickCallback}
        modulePosition={modulePosition}
      />
    );
};
